import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { APIService } from '../../common/services/api.service';

import { WholesalePage } from './wholesale.model';
import { AccountType, UserAccount } from '../../common/models/account';

export const wholesalePageResolver: ResolveFn<WholesalePage> = async () => {
  const apiService = inject(APIService);

  const page: WholesalePage = {
    loggedIn: false,
    isWholesale: false,
  };

  const userData: UserAccount | null | undefined = await apiService.authenticatedData();

  if (typeof userData !== 'undefined') {
    page.loggedIn = userData !== null;
    page.isWholesale = userData !== null && userData.accountType === AccountType.Wholesale;
  }

  return page;
};
